<template>
<b-card header-bg-variant="dark" border-variant="dark" header="SIGN LOAD SETTINGS" header-text-variant="white">
  <b-form @submit.prevent="onSubmit()">
  <div class="row">
    <div class="col-md-4">
      <b-card >
        <template slot="header">
          <h5 class="pull-left mb-0 mt-2">Loader 1 </h5>
          <div class="pull-right">
              <b-form-checkbox v-model="shipment_presets.loader1.active_loader" name="check-button" switch>
              </b-form-checkbox>
          </div>
        </template>
        <b-form-group
          class="mb-3"
          label="Terms & Condition : "
          label-for="tnc"
        >
          <b-form-textarea
            id="tnc"
            rows="2"
            v-model="shipment_presets.loader1.terms"
            placeholder="Enter your text"
            :formatter="format"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group
          class="mb-3"
          label-for="tnc"
        >
          <b-form-checkbox v-model="shipment_presets.loader1.fill_name" name="check-button" switch class="mb-3">
            Fill Name
          </b-form-checkbox>
        </b-form-group>
        <b-form-group label="Select your option for confirm delivery">
          <b-form-radio-group id="method_loader" v-model="shipment_presets.loader1.method" name="method_loader">
            <b-form-radio value="signature">Signature</b-form-radio>
            <b-form-radio value="photo">Photo</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-card>
    </div>
    <div class="col-md-4">
      <b-card >
          <template slot="header">
            <h5 class="pull-left mb-0 mt-2">Loader 2 </h5>
            <div class="pull-right">
                <b-form-checkbox v-model="shipment_presets.loader2.active_loader2" name="check-button" switch>
                </b-form-checkbox>
            </div>
          </template>
          <div class="div" v-if="shipment_presets.loader2.active_loader2 === false">
            <p><b>Please checklist for activated Loader 2</b></p>
          </div>
          <b-form-group
            class="mb-3"
            label="Terms & Condition : "
            v-if="shipment_presets.loader2.active_loader2 === true"
          >
            <b-form-textarea
              id="tnc2"
              rows="2"
              v-model="shipment_presets.loader2.terms2"
              placeholder="Enter your text"
              :formatter="format"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            class="mb-3"
            label-for="tnc2"
            v-if="shipment_presets.loader2.active_loader2 === true"
          >
            <b-form-checkbox v-model="shipment_presets.loader2.fill_name2" name="check-button" switch class="mb-3">
              Fill Name
            </b-form-checkbox>
          </b-form-group>
          <b-form-group v-if="shipment_presets.loader2.active_loader2 === true" label="Select your option for confirm delivery">
          <b-form-radio-group id="method_loader-2" v-model="shipment_presets.loader2.method2" name="method_loader2" >
            <b-form-radio value="signature">Signature</b-form-radio>
            <b-form-radio value="photo">Photo</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-card>
    </div>
    <div class="col-md-4">
      <b-card >
          <template slot="header">
            <h5 class="pull-left mb-0 mt-2">Driver </h5>
          </template>
          <b-form-group
            class="mb-3"
            label="Terms & Condition : "
          >
            <b-form-textarea
              id="tncd"
              rows="2"
              v-model="shipment_presets.driver.terms_driver"
              placeholder="Enter your text"
              :formatter="format"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            class="mb-3"
            label-for="tncd"
          >
            <b-form-checkbox v-model="shipment_presets.driver.fill_name_driver" name="check-button" switch class="mb-3">
              Fill Name
            </b-form-checkbox>
          </b-form-group>
          <b-form-group label="Select your option for confirm delivery">
          <b-form-radio-group id="method_driver" v-model="shipment_presets.driver.method_driver" name="method_driver">
            <b-form-radio value="signature">Signature</b-form-radio>
            <b-form-radio value="photo">Photo</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-card>
    </div>
    <div class="col-md-12">
      <b-card no-body>
          <template slot="header">
            <h5 class="pull-left mb-0 mt-2">Driver Confirm Load</h5>
            <div class="pull-right">
                <b-form-checkbox v-model="shipment_presets.driverConfirm" name="check-button" switch>
                </b-form-checkbox>
            </div>
          </template>
      </b-card>
    </div>
    <div class="col-md-12">
      <b-card no-body>
          <template slot="header">
            <h5 class="pull-left mb-0 mt-2">Enable Sorting Order</h5>
            <div class="pull-right">
                <b-form-checkbox v-model="shipment_presets.sortOrder" name="check-button" switch>
                </b-form-checkbox>
            </div>
          </template>
      </b-card>
    </div>
    <div class="col-md-12">
      <b-card no-body>
          <template slot="header">
            <h5 class="pull-left mb-0 mt-2">Driver Finish Manifest</h5>
            <div class="pull-right">
                <b-form-checkbox v-model="shipment_presets.driverFinishManifest" name="check-button" switch>
                </b-form-checkbox>
            </div>
          </template>
      </b-card>
    </div>
    <div class="col-md-12">
      <b-card >
        <template slot="header">
          <h5 class="pull-left mb-0 mt-2">Customer Confirm Delivery </h5>
        </template>
        <b-form-group label="Select your option for confirm delivery">
          <b-form-radio-group id="radio-group-2" v-model="shipment_presets.confirmType" name="radio-sub-component">
            <b-form-radio value="signature">Signature</b-form-radio>
            <b-form-radio value="photo">Photo</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-card>
    </div>
    <div class="col-md-12">
      <b-card >
        <template slot="header">
          <h5 class="pull-left mb-0 mt-2">Location </h5>
        </template>
        <b-form-group>
          <b-form-checkbox v-model="shipment_presets.location.code" name="code" >Location Code</b-form-checkbox>
          <b-form-checkbox v-model="shipment_presets.location.name" name="name" >Location Name</b-form-checkbox>
          <b-form-checkbox v-model="shipment_presets.location.address" name="address" >Location Address</b-form-checkbox>
        </b-form-group>
      </b-card>
    </div>
    <hr>
    <!-- <b-button
      type="submit"
      id="createBtn"
      class="mr-3"
      variant="primary">
      <span>Save changes</span>
    </b-button> -->
    <div>
      <b-button
        v-b-modal.modal-center
        id="createBtn"
        class="ml-3"
        variant="primary">
         Save Changes
      </b-button>
      <b-modal id="modal-center" centered title="Shipment Preset" @ok="onSubmit">
        <p class="my-4">Are you sure to save your changes?</p>
      </b-modal>
    </div>
  </div>
</b-form>
</b-card>
</template>
<script>
import { isEmpty } from 'lodash';

/* eslint-disable */
export default {
  data() {
    return {
      shipment_presets: {
        confirmType: 'signature',
        driverConfirm: false,
        sortOrder: false,
        driverFinishManifest: true,
        driverConfirm: false,
        company_id: null,
        loader1: {
          active_loader: true,
          terms: '',
          fill_name: false,
          method: 'signature',
        },
        loader2: {
          active_loader2: false,
          terms2: '',
          fill_name2: false,
          method2: '',
        },
        driver: {
          terms_driver: '',
          fill_name_driver: false,
          method_driver: 'signature',
        },
        location: {
          code: false,
          name: false,
          address: false,
        },
      },
      config: {
        sign_load_sheet: {
          start: {}
        },
      },
      text1: '',
      text2: '',
      checked: true,
      customerConfirm: '',
      checked2: false,
      fillName: false,
      fillName2: false,
      driverConfirm: false,
      locationCode: false,
      locationName: false,
      locationAddress: false,
      sortOrder: false,
      driverFinishManifest: false,
      selected: [], // Must be an array reference!
    };
  },
  created() {
    const { companyId } = this.$route.params;
    this.shipment_presets.company_id = parseInt(companyId);
    this.$store.commit('shipment_preset/SET_DETAIL_ID', companyId);
    this.$store.dispatch('shipment_preset/LOAD_DETAIL_DATA');
  },
  methods: {
    format(value) {
      return value.toLowerCase();
    },
    onSubmit() {
      let { companyId } = this.$route.params;
      this.config.sign_load_sheet.start = this.$set(this.config.sign_load_sheet.start, 1, this.shipment_presets);
      this.$store.dispatch(`shipment_preset/CREATE_DATA`, this.config).then((shipment_preset) => {
        this.$router.push(`/admin/companies/${companyId}/shipment_preset`);
      });
    },
  },
  computed: {
    detailedInfo() {
      const detailInfo = this.$store.getters['shipment_preset/get_detail_data'];
      return detailInfo;
    },
  },
  watch: {
    detailedInfo(data) {
      if(!isEmpty(data)){
        const presets = data[0];
        const { shipment_presets } = this;
        const { loader1 } = shipment_presets;
        data.loader1 = presets.config || {};
        shipment_presets.driverConfirm = presets.config.driverConfirm;
        shipment_presets.driverFinishManifest = presets.config.driverFinishManifest;
        shipment_presets.sortOrder = presets.config.sortOrder;
        shipment_presets.confirmType = presets.config.confirmType;
        //loader1
        shipment_presets.loader1.terms = presets.config.loader1.terms;
        shipment_presets.loader1.active_loader = presets.config.loader1.active_loader;
        shipment_presets.loader1.fill_name = presets.config.loader1.fill_name;
        shipment_presets.loader1.method = presets.config.loader1.method;
        //loader2
        shipment_presets.loader2.terms2 = presets.config.loader2.terms2;
        shipment_presets.loader2.active_loader2 = presets.config.loader2.active_loader2;
        shipment_presets.loader2.fill_name2 = presets.config.loader2.fill_name2;
        shipment_presets.loader2.method2 = presets.config.loader2.method2;
        //driver
        shipment_presets.driver.terms_driver = presets.config.driver.terms_driver;
        shipment_presets.driver.active_driver = presets.config.driver.active_driver;
        shipment_presets.driver.fill_name_driver = presets.config.driver.fill_name_driver;
        shipment_presets.driver.method_driver = presets.config.driver.method_driver;
        //location
        shipment_presets.location.name = presets.config.location.name;
        shipment_presets.location.code = presets.config.location.code;
        shipment_presets.location.address = presets.config.location.address;

      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/ShipmentPreset.vue